import React, { useState } from "react";
import { useQuery } from "react-query";
import { Navigate, Route, Routes } from "react-router-dom";
import ConfigRouter from "./features/config/ConfigRouter";
import Header from "./features/global/Header";
import HomeRouter from "./features/home/HomeRouter";
import RequestPinScreen from "./features/session/RequestPinScreen";
import OAuthCallbackScreen from "./features/session/OAuthCallbackScreen";
import { Spinner } from "@cinesys/ui/components";
import ApiService from "./services/ApiService";
import BillingListScreen from "./features/billing/BillingListScreen";
import JobRouter from "./features/jobs/JobRouter";

const AppRouter = () => {
  const {
    data: session,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["session"],
    queryFn: () => ApiService.getSession(),
    retry: 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  const [systemDomainId, setSystemDomainId] = useState<string | undefined>();

  return (
    <div>
      <Header
        showLinks={session?.isAdmin ?? false}
        systemDomainId={systemDomainId}
      ></Header>
      {isLoading ? (
        <Spinner />
      ) : isError ? (
        "Error loading session"
      ) : (
        <Routes>
          {session ? (
            <>
              <Route path="/config/*" element={<ConfigRouter />} />
              <Route
                path="/dashboard/:systemDomainId?/*"
                element={<HomeRouter setSystemDomainId={setSystemDomainId} />}
              ></Route>
              <Route path="/job/*" element={<JobRouter />} />
              <Route path="/billing" element={<BillingListScreen />} />
              <Route
                path="/"
                element={<Navigate to="/dashboard" replace />}
              ></Route>
            </>
          ) : (
            <>
              <Route path="/auth/callback" element={<OAuthCallbackScreen />} />
              <Route path="*" element={<RequestPinScreen />}></Route>
            </>
          )}
          <Route path="*" element="Not Found"></Route>
        </Routes>
      )}
      <div id="PortalTarget"></div>
    </div>
  );
};

export default AppRouter;
